import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { showToast } from '../components/dialog';
import Page from '../components/page';
import main from '../main';
import MCityPicker from '../components/m_city_picker/m_city_picker';
import Select from '../components/select/select';
import Radiobox from '../components/radioBox';
import { ProtocolType } from './protocolPage';
import SeamlessScroll from '../components/seamlessScroll';
import { apiGetBroadbandGoodsList, apiGetGoodsDetail, apiSubmitOrder } from '../api';
import { BussBandWidthDetail, RequestData } from '../types';
import { parseLocationParams, validateCardId, validateTel } from '../utils/utils';
export default function SharePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [option, setoption] = useState<any[]>([]);
  const [shareUserId, setShareUserId] = useState('');
  const [formData, setformData] = useState<RequestData>({})
  const [infoList, setinfoList] = useState<any>({})
  const [checkProtocol, setCheckProtocol] = useState(true);
  const [province, setProvince] = useState('');
  const [city, setCity] = useState('');
  const [area, setArea] = useState('');
  useEffect(() => {
    // let _d = parseLocationParams(location.search);
    let { userId: uid, goodsId } = parseLocationParams(location.search);
    if (uid) {
      setShareUserId(uid);
    }
    getShareInfo();
    getGoodsList(goodsId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  async function getGoodsList(goodsId: string) {

    const res = await apiGetGoodsDetail(goodsId)
    setinfoList(res?.data?.data || {})
  }
  async function handleSelectCity(res: string[]) {
    setProvince(res[0]);
    setCity(res[1]);
    setArea(res[2]);
  }
  // const goods = useSelector((state: AppStore) => state.goodsDetail[data?.goodsId]);

  async function getShareInfo() {
    const res = await apiGetBroadbandGoodsList()
    const { data } = res
    if (data.code === 200) {
      setoption(data.data?.map((item: BussBandWidthDetail) => {
        return {
          label: item.skuName,
          value: item.skuCode,
        }
      }) || [])
    }
  }
  function setFormChange(value: string, key: string) {

    setformData(v => {
      return {
        ...v,
        [key]: value
      }
    })
  }
  async function handleSave() {
    if (!formData.receiverName) {
      return showToast('请输入姓名');
    }
    if (!formData.receiverPhone) {
      return showToast('请输入手机号');
    }
    if (!validateTel(formData.receiverPhone)) {
      return showToast('请输入正确的手机号');
    }
    if (!formData.cardNo) {
      return showToast('请输入身份证');
    }
    if (!validateCardId(formData.cardNo)) {
      return showToast('请输入正确的身份证');
    }
    if (!province || !city || !area) {
      return showToast('请选择所在区域');
    }
    if (!formData.receiverAddress) {
      return showToast('请输入详细地址');
    }
    if (!formData.skuCode) {
      return showToast('请选择资费');
    }
    showToast('正在保存...');
    
    // const res = await apiSaveBandWidthOrder({
    const res = await apiSubmitOrder({
      ...formData,
      province,
      city,
      county: area,
      pageSource: 'h5',
      shareUserId,
      openId: main.openId,
      goodsId: infoList.id,
    })
    const { data } = res
    if (data.code === 200) {
      showToast('保存成功');
    } else {
      showToast(data.msg || '保存失败');
    }

  }
  function handleToShare() {
    let detail = infoList;
    navigate(`/share`, {
      state: {
        imgUrl: detail.goodsDetailImg ?? '',
        title: detail.goodsTitle ?? '',
        inviteUserId: '',
        goodsId: detail.id,
      },
    });
  }
  return (
    <Page
      className="bg-color-gred vw-100 vh-100 overflow-hidden d-flex-c"
      appBar={''}
      contentClassName="flex-1 h-1 overflow-y pb-60"
    >
      <div className="pos-a t-0 l-0 r-0 d-flex-r jc-between pv-20 ph-10">

        <div
          className="w-26 h-26 border-radius-20 bg-color-3-t5 d-flex-r ai-center jc-center"
          onClick={() => {
            navigate(-1);
          }}
        >
          <img className="w-24 h-24" src={main.pic('icon_back_white.png')} alt="" />
        </div>
        <div
          className="w-26 h-26 border-radius-20 bg-color-3-t5 d-flex-r ai-center jc-center"
        onClick={handleToShare}
        >
          <img className="w-20 h-20" src={main.pic('icon_export_white.png')} alt="" />
        </div>
      </div>
      <img src={infoList?.goodsListImg || main.pic('bgc.jpg')} alt="" className='vw-100' />
      <div className='d-flex-r ai-right jc-between pr-10 pl-10 mb-10' style={{ height: '50px', background: '#000', }}>
        <div className='line-height-40 text-color-white'>仅剩4张</div>
        <SeamlessScroll speed={30} minItems={1} >
          <div className='line-height-50 text-color-white font-size-14'>陈**   领取成功   一分钟前 </div>
          <div className='line-height-50 text-color-white font-size-14'>窦**   领取成功   一分钟前 </div>
          <div className='line-height-50 text-color-white font-size-14'>林**   领取成功   一分钟前 </div>
          <div className='line-height-50 text-color-white font-size-14'>万**   领取成功   一分钟前 </div>
          <div className='line-height-50 text-color-white font-size-14'>陈**   领取成功   一分钟前 </div>
          <div className='line-height-50 text-color-white font-size-14'>梁**   领取成功   一分钟前 </div>
          <div className='line-height-50 text-color-white font-size-14'>林**   领取成功   一分钟前 </div>
          <div className='line-height-50 text-color-white font-size-14'>李**   领取成功   一分钟前 </div>
        </SeamlessScroll>
      </div>

      <div className='bg-color-white pt-14 pb-14 ml-10 mr-10 border-radius-8'>
        <div className="mh-10 mt-5  d-flex-r ai-right font-size-14">
          <div className="w-100 pl-20">
            <span className="text-color-red">*</span><span className='text-input-title'>姓名</span>
          </div>
          <input
            className="flex-1 font-size-14"
            placeholder="请输入姓名（已加密）"
            value={formData.receiverName}
            onChange={(e) => setFormChange(e.target.value, 'receiverName')}
          />
        </div>
        <div className="mh-10 mt-20  d-flex-r ai-right font-size-14">
          <div className="w-100 pl-20">
            <span className="text-color-red">*</span><span className='text-input-title'>联系电话</span>
          </div>
          <input
            className="flex-1 font-size-14"
            placeholder="请输入联系电话"
            value={formData.receiverPhone}
            onChange={(e) => setFormChange(e.target.value, 'receiverPhone')}
          />
        </div>
        {
          formData.receiverPhone && formData.receiverName && <>
            <div className="mh-10 mt-20  d-flex-r ai-right font-size-14">
              <div className="w-100 pl-20">
                <span className="text-color-red">*</span><span className='text-input-title'>身份证</span>
              </div>
              <input
                className="flex-1 font-size-14"
                placeholder="请输入身份证"
                value={formData.cardNo}
                onChange={(e) => setFormChange(e.target.value, 'cardNo')}
              />
            </div>
            <div className="mh-10 mt-20  d-flex-r ai-right font-size-14">
              <div className="w-100 pl-20">
                <span className="text-color-red">*</span><span className='text-input-title'>所在区域</span>
              </div>
              <MCityPicker onChange={handleSelectCity} />
            </div>
            <div className="mh-10 mt-20  d-flex-r ai-right font-size-14">

              <input
                className="flex-1 font-size-14 pl-20 pr-20"
                placeholder="请输入详细地址（街道/小区/门牌号）"
                value={formData.receiverAddress}
                onChange={(e) => setFormChange(e.target.value, 'receiverAddress')}
              />
            </div>
            <div className="mh-10 mt-20  d-flex-r ai-right font-size-14">
              <div className="w-100 pl-20">
                <span className="text-color-red">*</span><span className='text-input-title'>选择资费</span>
              </div>
              <Select onChange={(e) => {
                setFormChange(e?.join(), 'skuCode')
                
              }} placeholder='资费' onlyValue value={formData?.goodsId} option={option} />
            </div>
          </>
        }
      </div>
      <div className="d-flex-r ai-center jc-center p-10" style={{ color: 'rgb(254, 236, 218)' }}>
        <Radiobox value={checkProtocol} onChange={(v) => setCheckProtocol(!checkProtocol)} />
        <span className="font-size-12 ml-5" onClick={() => setCheckProtocol(!checkProtocol)}>
          我已阅读并同意
        </span>
        <span
          className="font-size-12 ml-5"
          onClick={() => navigate('/protocol?type=' + ProtocolType.net_in)}
        >
          《入网协议》
        </span>
      </div>
      <div className=" ai-center">
        <div
          className="bw-100 h-40 d-flex-r jc-center mt-10 mb-10 btn-img"
          onClick={handleSave}
        >
          <img alt="" src={main.pic('new_cgDist_img5.png')} style={{ width: '80%' }} className='' />

          <div className="btuImgTxt font-size-14">立即提交</div>
        </div>
      </div>
      <img src={infoList?.goodsDetailImg || main.pic('bgb.png')} alt="" className='vw-100' />
    </Page>
  );
}
